import Api from "../api";

class TrafficSource {
  addTrafficSource = async (data) => {
    const { body } = await Api.post("trafficSource", data);
    return body;
  };

  fetchTrafficSource = async (id) => {
    const { body } = await Api.get(`trafficSource/${id}`);
    return body;
  };

  updateTrafficSource = async (id, data, params = {}) => {
    const { body } = await Api.put(`trafficSource/${id}`, data, params);
    return body;
  };

  fetchTrafficSources = async (
    params = { order_by: "id", order_direction: "ASC" }
  ) => {
    const { body } = await Api.get(`trafficSources`, null, params);
    return body;
  };

  deleteTrafficSource = async (id, params = {}) => {
    const { body } = await Api.destroy(`trafficSource/${id}`, {}, params);
    return body;
  };
}
// eslint-disable-next-line
export default new TrafficSource();
